export const marketingPl = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Darmowy Quickstart',
  'marketing.free.seo.description':
    'Pobierz darmowy Grymwyrd Quickstart — zasady gry i scenariusz jednorazowy, który możesz rozegrać dziś wieczorem. Wejdź do Mroku.',
  'marketing.free.eyebrow': 'Twoja bezpłatna przepustka',
  'marketing.free.heading': 'Wejdź do Mroku — za darmo',
  'marketing.free.subheadLead': 'Materiały',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— zasady podstawowe plus scenariusz przygody jednorazowej, który możesz uruchomić dziś wieczorem. Powiedz nam, dokąd go wysłać.',
  'marketing.free.benefit.rules.title': 'Zasady gry',
  'marketing.free.benefit.rules.body': 'Wszystko, czego potrzebujesz do gry, zebrane w skróconej formie.',
  'marketing.free.benefit.oneShot.title': 'Scenariusz jednorazowy',
  'marketing.free.benefit.oneShot.body': 'Gotowa do rozegrania przygoda grozy na pierwszy wieczór.',
  'marketing.free.benefit.livingWorld.title': 'Żywy świat',
  'marketing.free.benefit.livingWorld.body': 'Powiązania z encyklopedią, mapami i cotygodniowymi wydaniami.',
  'marketing.free.playInstead.heading': 'Wolisz po prostu grać?',
  'marketing.free.playInstead.body':
    'Utwórz pierwszą postać i rozegraj 10-minutowy solowy test — bez zakupu, bez zobowiązań.',
  'marketing.free.playInstead.cta': 'Utwórz postać',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Coś poszło nie tak. Spróbuj ponownie za chwilę.',
  'marketing.leadForm.ready': 'Twój darmowy Quickstart jest gotowy.',
  'marketing.leadForm.downloadCta': 'Pobierz swój Quickstart',
  'marketing.leadForm.alsoEmailed': 'Link wysłaliśmy również na twoją skrzynkę pocztową.',
  'marketing.leadForm.checkInbox': 'Sprawdź swoją skrzynkę — darmowy Quickstart jest w drodze.',
  'marketing.leadForm.emailPlaceholder': 'ty@przykład.pl',
  'marketing.leadForm.emailAriaLabel': 'Adres e-mail',
  'marketing.leadForm.defaultCta': 'Wyślij mi Quickstart',
  'marketing.leadForm.privacyNote':
    'Bez spamu — tylko Quickstart i okazjonalne krople wiedzy ze świata. Możesz się wypisać w każdej chwili.',
}
